import React from "react";
import { string } from "yup";
import Input from "./Base";
import InputMaskWithRef from "./InputMaskWithRef";
const zipCodeMask = [/\d/, /\d/, /\d/, /\d/, /\d/];
export const schema = string().required("A ZIP code is required.").matches(/\d{5}/, "Please enter a valid ZIP code");
export default React.forwardRef((props, ref) => /* @__PURE__ */ React.createElement(Input, {
  ref,
  label: "Zip Code",
  InputComponent: InputMaskWithRef,
  required: true,
  mask: zipCodeMask,
  inputMode: "numeric",
  ...props
}));
